export type ValidationRuleType = {
  entities: any;
  route: string;
  statuses: string[];
  validationRule: string;
  validationRuleDisplayZone: string;
  validationRuleGroup: string;
  validationRuleLevel: string;
  message: string;
  shortMessage: string;
};

export enum ValidationProcess {
  SUBMISSION = 'SUBMISSION',
  APPROVAL = 'APPROVAL',
  LINK_FINAL_TERMS = 'LINK_FINAL_TERMS',
}

export enum ValidationRuleLevel {
  WARN = 'WARN',
  ERROR = 'ERROR',
}
